import { useNavigate } from "react-router-dom";
import { CoalitionCardStars } from "./../CoalitionCardStars";
import { tokenSolver } from "../../utils";
import { empty_stars_all } from "./../../pngs";
import "./StarsBlock.scss";

export const StarsBlock = ({ stars = [] }) => {
  const navigate = useNavigate();

  const EmptyBlock = () => {
    return (
      <>
        <div className="empty-state">
          <div className="title">Junta tus estrellas</div>
          <div className="subtitle">
            Muy pronto podrás juntar estrellas para vivir experiencias únicas al
            participar
          </div>
          <div className="pic">
            <img src={empty_stars_all} alt="empty_stars_all" />
          </div>
        </div>
      </>
    );
  };

  const FilledBlock = ({ stars = [] }) => {
    return (
      <>
        <div className="content">
          <div className="title">Vive experiencias</div>
          <div className="subtitle">
            Sé la persona que junte más estrellas para ganar en las dinámicas
          </div>
          <div className="cards">
            {stars.map((promo, idx) => (
              <CoalitionCardStars
                key={idx}
                card={promo}
                promoClicked={() => {
                  navigate(`/stars/${promo.offer_id}?${tokenSolver()}`, {
                    state: { origin: "block" },
                  });
                }}
              />
            ))}
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      {!stars || stars.length === 0 ? (
        <EmptyBlock />
      ) : (
        <FilledBlock stars={stars} />
      )}
    </>
  );
};
